import { useQuery } from "@tanstack/react-query"

import { client } from "@/api"
import queryKeys from "@/api/queryKeys"

function useListAdvertisementImages() {
  return useQuery({
    queryKey: queryKeys.advertisements.images().queryKey,
    queryFn: () =>
      client.get(`/advertisements/images`).then((response) => response.data),
  })
}
export default useListAdvertisementImages
